"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _review_due_helpers = require("./review_due_helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var LIMIT = 20;
var FILTER_OVERRIDE_KEYS = ['reviewsFilterRetired', 'reviewsFilterCreatedAtDaysAgo', 'reviewsFilterDue', 'reviewsFilterDifficultyLabel', 'reviewsFilterDeckId', 'reviewsFilterCardTypeId'];
var ReviewIndexWrapper = function ReviewIndexWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(_props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [_props]);
      _initializerDefineProperty(_this, "selected", _descriptor, _this);
      _initializerDefineProperty(_this, "view", _descriptor2, _this);
      _initializerDefineProperty(_this, "filtersExpanded", _descriptor3, _this);
      _initializerDefineProperty(_this, "userRequestIsPending", _descriptor4, _this);
      _initializerDefineProperty(_this, "loadInitialReviews", _descriptor5, _this);
      _initializerDefineProperty(_this, "selectedSort", _descriptor6, _this);
      _initializerDefineProperty(_this, "searchQuery", _descriptor7, _this);
      _initializerDefineProperty(_this, "caretPosition", _descriptor8, _this);
      _initializerDefineProperty(_this, "showFilterOptions", _descriptor9, _this);
      _initializerDefineProperty(_this, "expandedCardIds", _descriptor0, _this);
      _initializerDefineProperty(_this, "selectedCardIds", _descriptor1, _this);
      _this.sortNonArchivedFirst = function (ary) {
        return ary.sort(function (a, b) {
          return a.archived === b.archived ? 0 : a.archived ? 1 : -1;
        });
      };
      _this.reviewDeckToOption = function (reviewDeck) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          withLanguage: false
        };
        return [reviewDeck.id, _this.reviewDeckName(reviewDeck.id, params)];
      };
      _this.cardDeckIsArchived = function (card) {
        var _AppUI$reviewDeckStor;
        if (!card) return false;
        return (_AppUI$reviewDeckStor = _state.AppUI.reviewDeckStore.indexData.find(function (item) {
          return item.id === card.deckId;
        })) === null || _AppUI$reviewDeckStor === void 0 ? void 0 : _AppUI$reviewDeckStor.archived;
      };
      _this.routeQueryChanged = function (previousLocationQuery, currentQuery) {
        return previousLocationQuery && previousLocationQuery !== JSON.stringify(currentQuery || {});
      };
      _this.clearFiltersFromQuery = function () {
        var _props$location;
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        return ['1', 'true'].includes("".concat(((_props$location = props.location) === null || _props$location === void 0 || (_props$location = _props$location.query) === null || _props$location === void 0 ? void 0 : _props$location.clear_filters) || ''));
      };
      _this.hasRouteOverrides = function () {
        var _props$location2;
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        return _this.clearFiltersFromQuery(props) || (0, _utils.isPresent)((_props$location2 = props.location) === null || _props$location2 === void 0 || (_props$location2 = _props$location2.query) === null || _props$location2 === void 0 ? void 0 : _props$location2.sort);
      };
      _this.applyRouteOverrides = function () {
        var _props$location3, _props$location4;
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        if (_this.clearFiltersFromQuery(props)) {
          FILTER_OVERRIDE_KEYS.forEach(function (key) {
            _this.selected[key] = '';
          });
        }
        if ((0, _utils.isPresent)((_props$location3 = props.location) === null || _props$location3 === void 0 || (_props$location3 = _props$location3.query) === null || _props$location3 === void 0 ? void 0 : _props$location3.sort)) {
          _this.selectedSort = props.location.query.sort;
        }
        _this.previousLocationQuery = JSON.stringify(((_props$location4 = props.location) === null || _props$location4 === void 0 ? void 0 : _props$location4.query) || {});
      };
      _this.rawFilterValue = function (item) {
        var raw = _this.selectedOrUser(item.userKey);
        if ((0, _utils.isBlank)(raw)) {
          return null;
        }
        if (item.multiSelect) {
          if ((0, _lodash.isArray)(raw)) {
            return raw.filter(function (value) {
              return (0, _utils.isPresent)(value);
            }).join(',');
          }
          return raw;
        }
        return raw;
      };
      _this.filterTagDisplay = function (item, displayValue) {
        if (item.forceTagDisplay) {
          return item.forceTagDisplay;
        }
        var tag = (0, _utils.formatFilterTag)(item, displayValue);
        if ((0, _utils.isPresent)(tag)) {
          return tag;
        }
        if ((0, _utils.isBlank)(displayValue) || !item.multiSelect) {
          return null;
        }
        var count = displayValue.split(',').filter(function (value) {
          return (0, _utils.isPresent)(value);
        }).length;
        if (count === 0) {
          return null;
        }
        return "".concat(item.label, ": ").concat(count, " Selected");
      };
      _this.onDelete = function (id) {
        _state.AppUI.set('reloadReviewDecks', true);
        _state.AppUI.cardStore.set('indexData', _state.AppUI.cardStore.indexData.filter(function (item) {
          return item.id !== id;
        }));
        _state.AppUI.cardStore.destroy({
          ids: {
            cardId: id
          }
        }, _this.getReviews);
      };
      _this.onResetReview = function (id) {
        var card = _state.AppUI.cardStore.indexData.find(function (item) {
          return item.id === id;
        });
        if (card && card.id) {
          card.onResetReview();
          _state.DeckUI.updateSpacedRepetitionFields(card);
          _state.AppUI.cardStore.destroyReviews({
            ids: {
              cardId: card.id
            }
          }, _lodash.noop);
        }
      };
      _this.keyIsMultiSelect = function (key) {
        var _this$filterSettings$;
        return (_this$filterSettings$ = _this.filterSettings.find(function (item) {
          return item.userKey === key;
        })) === null || _this$filterSettings$ === void 0 ? void 0 : _this$filterSettings$.multiSelect;
      };
      _this.onSetFilter = function (key, value) {
        var multiSelect = _this.keyIsMultiSelect(key);
        _this.resetSelectedCards();
        if (value === 'RANGE[,]') {
          value = null;
        }
        if (multiSelect) {
          _this.updateMultipleSelectFilter(key, value);
        } else {
          _this.selected[key] = value;
        }
        var data = {};
        data[key] = multiSelect ? _this.selected[key].join(',') : value;
        _state.AppUI.cardStore.clearIndexData();
        _this.loadInitialReviews = true;
        _this.updateUser(data, _this.getReviews);
      };
      _this.updateMultipleSelectFilter = function (key, value) {
        var _AppUI$user;
        var backendValue = (_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user[key];
        if ((0, _utils.isBlank)(value) || !backendValue) {
          _this.selected[key] = [];
        } else if ((0, _utils.isBlank)(_this.selected[key]) && (0, _lodash.isString)(backendValue)) {
          _this.selected[key] = backendValue.split(',');
        } else if ((0, _utils.isBlank)(_this.selected[key])) {
          _this.selected[key] = [];
        }
        _this.selected[key] = (0, _lodash.xor)(_this.selected[key], [value]);
      };
      _this.updateUser = function (data, callback) {
        (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
          if (_state.AppUI.user) {
            _state.AppUI.user.set(key, data[key]);
          }
          if ((0, _utils.isBlank)(_this.queuedUserData)) {
            _this.queuedUserData = {};
          }
          if (_this.userRequestIsPending) {
            _this.queuedUserData[key] = data[key];
          }
        });
        if (!_this.userRequestIsPending) {
          _this.userRequestIsPending = true;
          if (callback) {
            _this.callback = callback;
          }
          _state.AppUI.authUserStore.update({
            data: data
          }, _this.afterRequest);
        }
      };
      _this.afterRequest = function () {
        _this.userRequestIsPending = false;
        if ((0, _utils.isPresent)(_this.queuedUserData)) {
          _this.updateUser(_this.queuedUserData);
          _this.queuedUserData = {};
        } else {
          if (_this.callback) {
            _this.callback();
            _this.callback = null;
          }
        }
      };
      _this.activeFilter = function (value) {
        return (0, _utils.isPresent)(value) && value !== 'any';
      };
      _this.getReviews = function (callback) {
        _state.AppUI.cardStore.clearFilter();
        _state.AppUI.cardStore.setSort(_this.sort);
        _state.AppUI.cardStore.setLimit(LIMIT);
        _state.AppUI.cardStore.getIndex({
          filters: _this.filters,
          queryStrings: {
            my_reviews: true,
            language_id: _state.AppUI.targetLanguageId,
            search_query: (0, _utils.isPresent)(_this.searchQuery) ? _this.searchQuery : null
          }
        }, function (resp) {
          return _this.afterGetReviews(resp, callback);
        });
      };
      _this.onRefresh = function () {
        if (_state.AppUI.cardStore.requestCounter > 0) {
          return;
        }
        _this.resetSelectedCards();
        _this.getReviews();
      };
      _this.onToggleFiltersExpanded = function () {
        _this.filtersExpanded = !_this.filtersExpanded;
        if (_this.filtersExpanded) {
          _state.AppUI.expandModule('review-filters');
        } else {
          _state.AppUI.contractModule('review-filters');
        }
      };
      _this.selectedOrUser = function (key) {
        if (key in _this.selected) {
          return _this.selected[key];
        } else {
          return _state.AppUI.user[key];
        }
      };
      _this.afterGetReviews = function (resp, callback) {
        _state.AppUI.cardStore.setIndexData(resp);
        _this.loadInitialReviews = false;
        if ((0, _lodash.isFunction)(callback)) {
          callback();
        }
      };
      _this.onChangeSort = function (sort) {
        if (_this.sort === sort && _this.sort[0] !== '-') {
          _this.selectedSort = "-".concat(sort);
        } else {
          _this.selectedSort = sort;
        }
        _this.getReviews();
        _this.updateUser({
          reviews_list_sort: _this.selectedSort
        }, _lodash.noop);
      };
      _this.onUpdateSearchQuery = function (value, caretPosition) {
        _this.searchQuery = value;
        _this.caretPosition = caretPosition;
        clearInterval(_this.interval);
        _this.interval = setTimeout(_this.getReviews, 500);
      };
      _this.insertText = function (text, caretPosition) {
        var newValue;
        if (!caretPosition) {
          caretPosition = _this.searchQuery ? _this.searchQuery.length : 0;
        }
        if (_this.disabled) {
          return;
        }
        if (_this.searchQuery) {
          newValue = [_this.searchQuery.slice(0, caretPosition), text, _this.searchQuery.slice(caretPosition)].join('');
        } else {
          newValue = text;
        }
        _this.onUpdateSearchQuery(newValue, caretPosition + 1);
      };
      _this.reviewDeckName = function (reviewDeckId) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          withLanguage: false
        };
        if (!_this.reviewDeckStore.hasIndexData) {
          return '';
        }
        var reviewDeck = _this.reviewDeckStore.indexData.find(function (item) {
          return item.id === reviewDeckId;
        });
        if ((0, _utils.isBlank)(reviewDeck)) {
          return '';
        }
        var reviewDeckName = reviewDeck.name;
        if (params['withLanguage'] && !reviewDeckName.startsWith(_constants.Languages[reviewDeck.languageId || 'DE'])) {
          reviewDeckName += " (".concat(_constants.Languages[reviewDeck.languageId || 'DE'], ")");
        }
        if (reviewDeck.archived) {
          reviewDeckName += ' [Archived]';
        }
        return reviewDeckName;
      };
      _this.onToggleRetired = function (cardId, retired) {
        _state.DeckUI.cardStore.update({
          ids: {
            cardId: cardId
          },
          data: {
            retired: retired
          }
        }, _lodash.noop);
      };
      _this.setShowFilterOptions = function (showFilterOptions) {
        _this.showFilterOptions = showFilterOptions;
      };
      _this.cardIsExpanded = function (card) {
        return card && card.id && _this.expandedCardIds.includes(card.id);
      };
      _this.cardIsSelected = function (card) {
        return card && card.id && _this.selectedCardIds.includes(card.id);
      };
      _this.toggleCardExpand = function (card) {
        if (card && card.id) {
          _this.expandedCardIds = (0, _lodash.xor)(_this.expandedCardIds, [card.id]);
        }
      };
      _this.toggleCardSelect = function (card) {
        if (card && card.id) {
          _this.selectedCardIds = (0, _lodash.xor)(_this.selectedCardIds, [card.id]);
        }
      };
      _this.isReviewPastDue = function (item) {
        var _AppUI$user2;
        return (0, _review_due_helpers.reviewIsPastDue)(item === null || item === void 0 ? void 0 : item.reviewAfter, (_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.reviewsDueAtBeginningOfDay);
      };
      _this.reviewAfterText = function (item) {
        var _AppUI$user3;
        return (0, _review_due_helpers.formatReviewAfterText)(item === null || item === void 0 ? void 0 : item.reviewAfter, (_AppUI$user3 = _state.AppUI.user) === null || _AppUI$user3 === void 0 ? void 0 : _AppUI$user3.reviewsDueAtBeginningOfDay);
      };
      _this.cardIsNew = function (card) {
        var _card$createdAt;
        return Boolean((card === null || card === void 0 || (_card$createdAt = card.createdAt) === null || _card$createdAt === void 0 ? void 0 : _card$createdAt.dateObj) && Date.now() - card.createdAt.dateObj.getTime() < 60 * 60 * 1000);
      };
      _this.cardDeckName = function (card) {
        if (!card) return 'No Deck';
        var deckInfo = _this.allReviewDeckOptions.find(function (option) {
          return option[0] == card.deckId;
        });
        return (0, _utils.isPresent)(deckInfo) ? deckInfo[1] : 'No Deck';
      };
      _this.toggleExpandAll = function () {
        if (!_this.allCardsExpanded && _state.DeckUI.cardStore.hasIndexData) {
          var _DeckUI$cardStore$ind;
          _this.expandedCardIds = (_DeckUI$cardStore$ind = _state.DeckUI.cardStore.indexData) === null || _DeckUI$cardStore$ind === void 0 ? void 0 : _DeckUI$cardStore$ind.map(function (item) {
            return item.id;
          });
        } else {
          _this.expandedCardIds = [];
        }
      };
      _this.toggleSelectAll = function () {
        if (_this.allSelected) {
          _this.selectedCardIds = [];
        } else {
          var _DeckUI$cardStore$ind2;
          _this.selectedCardIds = (_DeckUI$cardStore$ind2 = _state.DeckUI.cardStore.indexData) === null || _DeckUI$cardStore$ind2 === void 0 ? void 0 : _DeckUI$cardStore$ind2.map(function (item) {
            return item.id;
          });
        }
      };
      _this.resetSelectedCards = function () {
        _this.expandedCardIds = [];
        _this.selectedCardIds = [];
      };
      _this.cardTypeName = function (card) {
        if (!card) return '';
        if (_state.AppUI.cardTypeStore.hasIndexData) {
          var cardType = _state.AppUI.cardTypeStore.indexData.find(function (item) {
            return item.id === card.cardTypeId;
          });
          if (cardType) {
            return cardType.name;
          }
          return card.cardType.name;
        }
      };
      _this.applyRouteOverrides(_props);
      if (_this.hasRouteOverrides(_props)) {
        _state.AppUI.cardStore.clearIndexData();
      }
      if (!_state.AppUI.cardTypeStore.hasIndexData) {
        _state.AppUI.cardTypeStore.getIndex({
          filters: {
            allow_reviews: true
          },
          sort: 'name'
        });
      }
      _this.disposer = (0, _mobx.autorun)(function () {
        if (_state.AppUI.userIsLoaded && !_this.loadInitialReviews) {
          _this.loadInitialReviews = true;
          _this.disposer && _this.disposer();
          _this.getReviews();
          _this.filtersExpanded = !_state.AppUI.user.moduleIsContracted('review-filters');
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!_state.AppUI.layout.isNative) {
          var _this$props$params, _window$location$href;
          var page = ((_this$props$params = this.props.params) === null || _this$props$params === void 0 ? void 0 : _this$props$params.page) || window.location.href && ((_window$location$href = window.location.href.split('page/')[1]) === null || _window$location$href === void 0 ? void 0 : _window$location$href.split('?')[0]);
          _state.AppUI.cardStore.setPage(page);
        }
        _state.AppUI.createEvent('reviews - view reviews list');
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this$props$location, _this$props$location2;
        if (this.routeQueryChanged(this.previousLocationQuery, (_this$props$location = this.props.location) === null || _this$props$location === void 0 ? void 0 : _this$props$location.query)) {
          this.applyRouteOverrides(this.props);
          _state.AppUI.cardStore.clearIndexData();
          this.loadInitialReviews = true;
          this.getReviews();
        }
        this.previousLocationQuery = JSON.stringify(((_this$props$location2 = this.props.location) === null || _this$props$location2 === void 0 ? void 0 : _this$props$location2.query) || {});
        if (!_state.AppUI.cardStore.hasIndexData && !_state.AppUI.cardStore.initialRequestReceived && _state.AppUI.cardStore.requestCounter === 0) {
          this.loadInitialReviews = true;
          this.getReviews();
        }
      }
    }, {
      key: "filteredItemsCount",
      get: function get() {
        return _state.AppUI.cardStore.hasIndexData ? _state.AppUI.cardStore.indexData[0].cardsCount : 0;
      }
    }, {
      key: "noFiltersSelectedMessage",
      get: function get() {
        return 'No Filter Selected.';
      }
    }, {
      key: "reviewDeckOptions",
      get: function get() {
        var _this$sortNonArchived,
          _this2 = this;
        return (_this$sortNonArchived = this.sortNonArchivedFirst(_state.AppUI.reviewDeckStore.indexData.filter(function (item) {
          return item.languageId === _state.AppUI.targetLanguageId;
        }))) === null || _this$sortNonArchived === void 0 ? void 0 : _this$sortNonArchived.map(function (item) {
          return _this2.reviewDeckToOption(item);
        });
      }
    }, {
      key: "filterSettings",
      get: function get() {
        var _AppUI$cardTypeStore$,
          _this3 = this;
        var settings = [{
          key: 'retired',
          userKey: 'reviewsFilterRetired',
          label: 'Retired',
          includeBlank: true,
          description: 'Cards that are retired will not show up in your reviews by default. Cards are retired after you have seen them long enough that we consider them to be learned.',
          options: [[true, 'Yes'], [false, 'No']],
          filterType: 'select'
        }, {
          hide: true,
          key: 'created_at_days_ago',
          userKey: 'reviewsFilterCreatedAtDaysAgo',
          label: 'Created At',
          includeBlank: true,
          options: [[1, 'Last 1 Day'], [7, 'Last 7 Days'], [30, 'Last 30 Days'], [90, 'Last 90 Days']],
          filterType: 'select'
        }, {
          key: 'due',
          userKey: 'reviewsFilterDue',
          description: 'Cards are due to be reviewed at intervals that depend on your past experience with that card.',
          label: 'Next Due',
          includeBlank: true,
          options: [['past-due', 'Past Due'], ['caught-up', 'Caught Up']],
          filterType: 'select'
        }, {
          key: 'difficulty_label',
          userKey: 'reviewsFilterDifficultyLabel',
          description: 'We rank the difficulty of each card based on your experience with that card.',
          label: 'Difficulty',
          includeBlank: true,
          options: _constants.Constants.DIFFICULTY_LABEL_OPTIONS,
          filterType: 'select'
        }, {
          multiSelect: true,
          key: 'deck_id',
          userKey: 'reviewsFilterDeckId',
          label: 'Review Deck',
          includeBlank: true,
          options: this.reviewDeckOptions,
          filterType: 'select'
        }, {
          multiSelect: true,
          key: 'card_type_id',
          userKey: 'reviewsFilterCardTypeId',
          label: 'Card Type',
          includeBlank: true,
          options: (_AppUI$cardTypeStore$ = _state.AppUI.cardTypeStore.indexData) === null || _AppUI$cardTypeStore$ === void 0 ? void 0 : _AppUI$cardTypeStore$.map(function (item) {
            return [item.id, item.name];
          }),
          filterType: 'select'
        }];
        return settings === null || settings === void 0 ? void 0 : settings.map(function (item) {
          var _this3$selectedOrUser;
          var optionsAry = item.options.map(function (option) {
            return option[0];
          });
          var selectedOrUserAry = (0, _utils.isPresent)(_this3.selectedOrUser(item.userKey)) ? (0, _lodash.isString)(_this3.selectedOrUser(item.userKey)) && item.multiSelect ? (_this3$selectedOrUser = _this3.selectedOrUser(item.userKey)) === null || _this3$selectedOrUser === void 0 ? void 0 : _this3$selectedOrUser.split(',') : _this3.selectedOrUser(item.userKey) : [];
          var filteredSelectedOrUser = (0, _lodash.isArray)(selectedOrUserAry) && item.multiSelect ? selectedOrUserAry === null || selectedOrUserAry === void 0 ? void 0 : selectedOrUserAry.filter(function (value) {
            return optionsAry.includes(value);
          }).join(',') : selectedOrUserAry;
          var rawValue = _this3.rawFilterValue(item);
          var displayValue = item.forceValue || ((0, _utils.isPresent)(filteredSelectedOrUser) ? filteredSelectedOrUser : rawValue);
          var hsh = {
            tagDisplay: _this3.filterTagDisplay(item, displayValue),
            value: displayValue
          };
          return (0, _lodash.merge)(item, hsh);
        });
      }
    }, {
      key: "reviewDeckStore",
      get: function get() {
        return _state.AppUI.reviewDeckStore;
      }
    }, {
      key: "allReviewDeckOptions",
      get: function get() {
        var _AppUI$filteredReview,
          _this4 = this,
          _this$reviewDeckStore;
        return _state.AppUI.layout.isNative ? (_AppUI$filteredReview = _state.AppUI.filteredReviewDecks) === null || _AppUI$filteredReview === void 0 ? void 0 : _AppUI$filteredReview.map(function (item) {
          return _this4.reviewDeckToOption(item);
        }) : (_this$reviewDeckStore = this.reviewDeckStore.indexData.filter(function (item) {
          return !item.archived;
        })) === null || _this$reviewDeckStore === void 0 ? void 0 : _this$reviewDeckStore.map(function (item) {
          return _this4.reviewDeckToOption(item, {
            withLanguage: true
          });
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.disposer && this.disposer();
        clearTimeout(this.interval);
        if ((0, _utils.isPresent)(this.searchQuery)) {
          this.searchQuery = null;
          _state.AppUI.cardStore.clearIndexData();
        }
        this.resetSelectedCards();
      }
    }, {
      key: "sort",
      get: function get() {
        return this.selectedSort || _state.AppUI.user.reviewsListSort || 'review_after';
      }
    }, {
      key: "deck",
      get: function get() {
        var _this5 = this;
        return _state.AppUI.reviewDeckStore.indexData.find(function (item) {
          return item.id === _this5.deckId;
        });
      }
    }, {
      key: "cardType",
      get: function get() {
        var _this6 = this;
        return _state.AppUI.cardTypeStore.indexData.find(function (item) {
          return item.id === _this6.cardTypeId;
        });
      }
    }, {
      key: "deckId",
      get: function get() {
        return this.selectedOrUser('deck_id');
      }
    }, {
      key: "cardTypeId",
      get: function get() {
        return this.selectedOrUser('card_type_id');
      }
    }, {
      key: "reviewAfter",
      get: function get() {
        return this.selectedOrUser('review_after');
      }
    }, {
      key: "hasActiveFilter",
      get: function get() {
        var _this7 = this;
        return (0, _utils.isPresent)(this.filterSettings.filter(function (item) {
          return !item.hide && (0, _utils.isPresent)(_this7.rawFilterValue(item));
        }));
      }
    }, {
      key: "showPagination",
      get: function get() {
        return !this.showSpinner && (_state.AppUI.cardStore.page > 1 || _state.AppUI.cardStore.indexData.length > 0);
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return _state.AppUI.cardStore.requestCounter > 0;
      }
    }, {
      key: "filters",
      get: function get() {
        var _this8 = this;
        var filters = {};
        (0, _lodash.each)(this.filterSettings, function (item) {
          var value = _this8.rawFilterValue(item);
          if ((0, _utils.isPresent)(value)) {
            filters[item.key] = item.filterValue || value;
          }
        });
        return filters;
      }
    }, {
      key: "showExactReviewAfterSettingOff",
      get: function get() {
        var _AppUI$user4;
        return (0, _review_due_helpers.showExactReviewAfter)((_AppUI$user4 = _state.AppUI.user) === null || _AppUI$user4 === void 0 ? void 0 : _AppUI$user4.reviewsDueAtBeginningOfDay);
      }
    }, {
      key: "allCardsExpanded",
      get: function get() {
        var _DeckUI$cardStore$ind3;
        return _state.DeckUI.cardStore.hasIndexData && this.expandedCardIds.length === ((_DeckUI$cardStore$ind3 = _state.DeckUI.cardStore.indexData) === null || _DeckUI$cardStore$ind3 === void 0 ? void 0 : _DeckUI$cardStore$ind3.length);
      }
    }, {
      key: "allSelected",
      get: function get() {
        var _AppUI$cardStore$inde;
        return _state.AppUI.cardStore.hasIndexData && this.selectedCardIds.length === ((_AppUI$cardStore$inde = _state.AppUI.cardStore.indexData) === null || _AppUI$cardStore$inde === void 0 ? void 0 : _AppUI$cardStore$inde.length);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          view: this.view,
          reviewDeckOptions: this.reviewDeckOptions,
          allReviewDeckOptions: this.allReviewDeckOptions,
          filtersExpanded: this.filtersExpanded,
          onToggleFiltersExpanded: this.onToggleFiltersExpanded,
          onSetFilter: this.onSetFilter,
          cardTypeId: this.cardTypeId,
          retired: this.retired,
          getReviews: this.getReviews,
          onChangeSort: this.onChangeSort,
          difficultyLabel: this.difficultyLabel,
          showSpinner: this.showSpinner,
          sort: this.sort,
          searchQuery: this.searchQuery,
          caretPosition: this.caretPosition,
          onUpdateSearchQuery: this.onUpdateSearchQuery,
          insertText: this.insertText,
          showPagination: this.showPagination,
          onDelete: this.onDelete,
          onResetReview: this.onResetReview,
          reviewDeckName: this.reviewDeckName,
          onToggleRetired: this.onToggleRetired,
          filterSettings: this.filterSettings,
          setShowFilterOptions: this.setShowFilterOptions,
          showFilterOptions: this.showFilterOptions,
          hasActiveFilter: this.hasActiveFilter,
          noFiltersSelectedMessage: this.noFiltersSelectedMessage,
          filteredItemsCount: this.filteredItemsCount,
          page: _state.AppUI.cardStore.page,
          expandedCardIds: this.expandedCardIds,
          selectedCardIds: this.selectedCardIds,
          cardIsExpanded: this.cardIsExpanded,
          cardIsSelected: this.cardIsSelected,
          toggleCardExpand: this.toggleCardExpand,
          toggleCardSelect: this.toggleCardSelect,
          isReviewPastDue: this.isReviewPastDue,
          cardIsNew: this.cardIsNew,
          reviewAfterText: this.reviewAfterText,
          showExactReviewAfter: this.showExactReviewAfterSettingOff,
          cardDeckName: this.cardDeckName,
          toggleExpandAll: this.toggleExpandAll,
          allCardsExpanded: this.allCardsExpanded,
          resetSelectedCards: this.resetSelectedCards,
          allSelected: this.allSelected,
          toggleSelectAll: this.toggleSelectAll,
          cardTypeName: this.cardTypeName,
          cardDeckIsArchived: this.cardDeckIsArchived,
          onRefresh: this.onRefresh
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "view", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'card';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "filtersExpanded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "userRequestIsPending", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "loadInitialReviews", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "selectedSort", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "searchQuery", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "caretPosition", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "showFilterOptions", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "expandedCardIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "selectedCardIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "filteredItemsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredItemsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "noFiltersSelectedMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "noFiltersSelectedMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allReviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "allReviewDeckOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewAfter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewAfter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasActiveFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasActiveFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPagination", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPagination"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExactReviewAfterSettingOff", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExactReviewAfterSettingOff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allCardsExpanded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "allCardsExpanded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allSelected", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "allSelected"), _class2.prototype), _class2)) || _class;
};
ReviewIndexWrapper.displayName = 'ReviewIndexWrapper';
var _default = exports["default"] = ReviewIndexWrapper;